export default "__VITE_ASSET__CcnFPDDm__"